document.addEventListener("DOMContentLoaded", () => {

  const container = document.getElementById("diamond-detail-container");
  if (!container) return;

  const params = new URLSearchParams(window.location.search);
  const stock  = params.get("stock");

  if (!stock) { container.innerHTML = "<p>No diamond selected.</p>"; return; }

  let d = null;
  try {
    const cached = sessionStorage.getItem("diamond_" + stock);
    if (cached) d = JSON.parse(cached);
  } catch(e) {}

  if (d) {
    render(d);
  } else {
    container.innerHTML = "<div class='diamond-detail-loading'>Loading diamond details...</div>";
    fetch("https://nancy.kodllin.com/apis/api/getStockN?auth_key=upttdtcekrao", { method: "POST" })
      .then(r => r.json())
      .then(json => {
        const all = Array.isArray(json) ? json : (json.data || json.diamonds || json.items || []);
        d = all.find(x => x.stockNo === stock);
        if (!d) { container.innerHTML = "<p>Diamond not found.</p>"; return; }
        render(d);
      })
      .catch(err => {
        console.error(err);
        container.innerHTML = "<p>Failed to load diamond details.</p>";
      });
  }

  function render(d) {
    const fallback   = "https://cdn.shopify.com/s/files/1/0823/5810/8395/files/images.png?v=1784969155";
    const price      = parseFloat(d.totalPrice)  || 0;
    const pricePerCt = parseFloat(d.pricePerCt)  || 0;
    const priceStr   = price.toLocaleString("en-US", {minimumFractionDigits:2, maximumFractionDigits:2});
    const ppcStr     = pricePerCt.toLocaleString("en-US", {minimumFractionDigits:2, maximumFractionDigits:2});

    container.innerHTML = `
      <div class="diamond-detail-grid">

        <!-- LEFT: Media -->
        <div class="diamond-detail-media">
          ${d.videoLink
            ? `<iframe src="${d.videoLink}" frameborder="0" allowfullscreen class="diamond-video"></iframe>`
            : `<img src="${d.imageLink || fallback}" alt="${d.shape}" onerror="this.onerror=null;this.src='${fallback}';">`
          }
          <div class="diamond-detail-links">
            ${d.imageLink ? `<a href="${d.imageLink}" target="_blank">🔍 Image</a>`       : ""}
            ${d.certiFile ? `<a href="${d.certiFile}" target="_blank">📄 Certificate</a>` : ""}
            ${d.videoLink ? `<a href="${d.videoLink}" target="_blank">▶ Video</a>`        : ""}
          </div>
        </div>

        <!-- RIGHT: Info -->
        <div class="diamond-detail-info">
          <h1>${d.weight}ct ${d.shape} Diamond</h1>
          <div class="diamond-detail-price">
            $${priceStr}
            <span class="price-per-ct">$${ppcStr}/ct</span>
          </div>

          <div class="diamond-badge-row">
            ${d.lab     ? `<span class="diamond-badge certified">✓ ${d.lab} Certified</span>` : ""}
            ${d.status  ? `<span class="diamond-badge">${d.status}</span>`                     : ""}
            ${d.growthType ? `<span class="diamond-badge">${d.growthType}</span>`              : ""}
            ${d.location   ? `<span class="diamond-badge">📍 ${d.location}</span>`            : ""}
          </div>

          <table class="diamond-detail-table">
            <tr><td>Stock No</td>    <td>${d.stockNo}</td></tr>
            <tr><td>Shape</td>       <td>${d.shape}</td></tr>
            <tr><td>Carat</td>       <td>${d.weight} ct</td></tr>
            <tr><td>Color</td>       <td>${d.color}${d.fancyColor ? ` — ${d.fancyColorIntensity} ${d.fancyColor}` : ""}</td></tr>
            <tr><td>Clarity</td>     <td>${d.clarity}</td></tr>
            <tr><td>Cut</td>         <td>${d.cut || "-"}</td></tr>
            <tr><td>Polish</td>      <td>${d.polish}</td></tr>
            <tr><td>Symmetry</td>    <td>${d.symmetry}</td></tr>
            <tr><td>Fluorescence</td><td>${d.fluorescenceIntensity}</td></tr>
            <tr><td>Lab</td>         <td>${d.lab}</td></tr>
            <tr><td>Report No</td>   <td>${d.reportNo}</td></tr>
            <tr><td>Measurements</td><td>${d.measurements}</td></tr>
            <tr><td>Depth</td>       <td>${d.depth}%</td></tr>
            <tr><td>Table</td>       <td>${d.table}%</td></tr>
            <tr><td>Girdle</td>      <td>${d.girdleThin} – ${d.girdleThick}</td></tr>
            <tr><td>Culet</td>       <td>${d.culetSize}</td></tr>
            <tr><td>Eye Clean</td>   <td>${d.eyeClean}</td></tr>
            <tr><td>Shade</td>       <td>${d.shade}</td></tr>
            <tr><td>Location</td>    <td>${d.city}, ${d.country}</td></tr>
          </table>

          <a href="/pages/loose-diamond" class="diamond-back-btn">← Back to Diamonds</a>
        </div>
      </div>

      <!-- ── Enquiry Form ───────────────────────────────── -->
      <div class="diamond-enquiry-section">
        <h2>Enquire About This Diamond</h2>
        <p class="enquiry-subtitle">Interested in this diamond? Fill in your details and our team will get back to you shortly.</p>

        <div class="enquiry-diamond-summary">
          <strong>${d.weight}ct ${d.shape}</strong> &nbsp;|&nbsp;
          Color: <strong>${d.color}</strong> &nbsp;|&nbsp;
          Clarity: <strong>${d.clarity}</strong> &nbsp;|&nbsp;
          Lab: <strong>${d.lab}</strong> &nbsp;|&nbsp;
          Report: <strong>${d.reportNo}</strong><br>
          Price: <strong>$${priceStr}</strong> &nbsp;($${ppcStr}/ct)
        </div>

        <form id="enquiry-form">
          <div class="enquiry-form-grid">
            <div class="enquiry-field">
              <label>Full Name *</label>
              <input type="text" name="name" placeholder="John Smith" required>
            </div>
            <div class="enquiry-field">
              <label>Email Address *</label>
              <input type="email" name="email" placeholder="john@example.com" required>
            </div>
            <div class="enquiry-field">
              <label>Phone Number</label>
              <input type="tel" name="phone" placeholder="+1 (555) 000-0000">
            </div>
            <div class="enquiry-field">
              <label>Country</label>
              <input type="text" name="country" placeholder="United States">
            </div>
            <div class="enquiry-field full-width">
              <label>Message</label>
              <textarea name="message" placeholder="Any specific questions or requirements about this diamond..."></textarea>
            </div>
          </div>

          <input type="hidden" name="stock"   value="${d.stockNo}">
          <input type="hidden" name="diamond" value="${d.weight}ct ${d.shape} ${d.color}/${d.clarity} ${d.lab} #${d.reportNo} — $${priceStr}">

          <button type="submit" class="enquiry-submit-btn">Send Enquiry →</button>
        </form>

        <div id="enquiry-success" style="display:none;" class="enquiry-success">
          <h3>✅ Enquiry Sent!</h3>
          <p>Thank you! Our team will contact you within 24 hours.</p>
        </div>
      </div>
    `;

    // Form submit
    document.getElementById("enquiry-form").addEventListener("submit", async (e) => {
      e.preventDefault();
      const form    = e.target;
      const btn     = form.querySelector(".enquiry-submit-btn");
      btn.disabled  = true;
      btn.innerHTML = "Sending...";

      const body = `Diamond Enquiry\n\nDiamond: ${form.diamond.value}\nStock: ${form.stock.value}\n\nName: ${form.name.value}\nEmail: ${form.email.value}\nPhone: ${form.phone.value || "N/A"}\nCountry: ${form.country.value || "N/A"}\nMessage: ${form.message.value || "N/A"}`;

      try {
        const res = await fetch("/contact", {
          method: "POST",
          headers: { "Content-Type": "application/x-www-form-urlencoded" },
          body: new URLSearchParams({
            form_type: "contact",
            utf8: "✓",
            "contact[name]":  form.name.value,
            "contact[email]": form.email.value,
            "contact[phone]": form.phone.value,
            "contact[body]":  body,
          }),
        });

        if (res.ok) {
          form.style.display = "none";
          document.getElementById("enquiry-success").style.display = "block";
          document.getElementById("enquiry-success").scrollIntoView({ behavior: "smooth" });
        } else {
          throw new Error("Failed");
        }
      } catch(err) {
        btn.disabled  = false;
        btn.innerHTML = "Send Enquiry →";
        alert("Failed to send. Please try again.");
      }
    });
  }

});
